import { createFileRoute, redirect } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { canAccessAdminArea } from "@/features/auth/access"
import { useAuthStore } from "@/features/auth/store"
import { PushCampaignsTable } from "@/features/push-campaigns/components/PushCampaignsTable"

export const Route = createFileRoute("/_authed/push-campaigns")({
  // Admin-only: bu sayfa son kullanıcıların telefonuna doğrudan bildirim gönderiyor.
  // Backend AdminOnly → 403; bu graceful redirect. Nav'daki canAccess ile AYNI predicate
  // (nav-config.ts'deki kural) — menü ile erişim asla ayrışmasın.
  //
  // NOT: /notifications yolu "Bildirim Kuralları" (e-posta dağıtımı) tarafından kullanılıyor,
  // bu yüzden ayrı bir yol.
  beforeLoad: () => {
    if (!canAccessAdminArea(useAuthStore.getState().user)) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: PushCampaignsPage,
})

function PushCampaignsPage() {
  const { t } = useTranslation("push-campaigns")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <PushCampaignsTable />
    </div>
  )
}
